import React, { useState } from 'react';
import { config } from '../config';
import { useNotification } from '../components/Notification';
import './Contact.css';

function Contact() {
  const { showNotification } = useNotification();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${config.API_URL || 'https://api.garagedesk.net/api'}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Fehler beim Senden der Nachricht');
      }

      showNotification('Nachricht erfolgreich gesendet! Wir melden uns schnellstmöglich bei Ihnen.', 'success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      e.target.reset();
    } catch (error) {
      console.error('Contact form error:', error);
      showNotification(error.message || 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1>Kontakt</h1>
        <p className="contact-intro">
          Haben Sie Fragen oder Anregungen? Wir freuen uns auf Ihre Nachricht!
        </p>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">E-Mail-Adresse *</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Betreff *</label>
            <input
              type="text"
              id="subject"
              value={formData.subject}
              onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Nachricht *</label>
            <textarea
              id="message"
              rows="8"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              required
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Wird gesendet...' : 'Nachricht senden'}
          </button>
        </form>

        <div className="contact-info">
          <h2>Kontaktinformationen</h2>
          <p>
            <strong>E-Mail:</strong> <a href="mailto:mail@thomas-ringler.de">mail@thomas-ringler.de</a>
          </p>
          <p>
            <strong>Adresse:</strong><br />
            Thomas Ringler<br />
            Am Pfalzbach 52B<br />
            91413 Neustadt/Aisch
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;

